import { createContext } from 'react';

const dialog = () => {};
dialog.alert = () => {};
dialog.confirm = () => {};
export const DialogContext = createContext({ dialog });
export const DialogComponentContext = createContext({ onClose: () => {} });
